import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import GoogleMapsLoader from '@/services/GoogleMapsLoader';
import pjson from "../package.json";
import AppSwiper from "@/components/AppSwiper.vue";
import AppSwiperSlide from "@/components/AppSwiperSlide.vue";
import lineClamp from "vue-line-clamp";
import 'swiper/swiper-bundle.css';
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCcVisa,
  faCcMastercard,
  faCcDiscover,
  faCcAmex,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import IdleVue from "idle-vue";

const idleTime = 3600000;

library.add(faCcAmex, faCcDiscover, faCcMastercard, faCcVisa);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component('swiper', AppSwiper);
Vue.component('swiper-slide', AppSwiperSlide);

Vue.use(lineClamp, { importCss: true });

GoogleMapsLoader.init(process.env.VUE_APP_GOOGLE_MAPS_API_KEY, {
  language: 'en',
  region: 'US',
  version: 'weekly',
});

Vue.use(IdleVue, { idleTime, store });

Vue.config.productionTip = false;
Vue.config.ignoredElements = [/^gmp-/];

console.log(`${pjson.fixVersion}`);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
